import { useEffect } from 'react';
import { loadGoogleTranslate, prepareStoredGoogleTranslateLanguage, getStoredTranslateLanguage, GOOGLE_TRANSLATE_ELEMENT_ID } from '../../utils/googleTranslate';
import { startTamilGlossary } from '../../utils/tamilGlossary';

// Mounted once at the app root (see App.js) so the translate script + hidden
// widget stay alive across every route — a language picked on /language
// keeps translating the whole site, not just that one page.
const GoogleTranslateWidget = () => {
    useEffect(() => {
        prepareStoredGoogleTranslateLanguage();
        // Google's translate script (about 110 KB) is only needed once a language other than English is chosen; choosing one reloads the page
        if (getStoredTranslateLanguage() !== 'en') loadGoogleTranslate();
        if (getStoredTranslateLanguage() === 'ta') return startTamilGlossary();
    }, []);

    return (
        <>
            <div id={GOOGLE_TRANSLATE_ELEMENT_ID} className="notranslate" style={styles.hidden}></div>
            <style>{`
                .goog-te-banner-frame, .VIpgJd-ZVi9od-ORHb-OEVmcd { display: none !important; visibility: hidden !important; height: 0 !important; }
                body { top: 0px !important; position: static !important; }
                .goog-tooltip, .goog-tooltip:hover { display: none !important; }
                .goog-text-highlight { background: none !important; box-shadow: none !important; }
                .goog-logo-link, .goog-te-gadget span { display: none !important; }
                .goog-te-gadget { height: 0 !important; overflow: hidden !important; color: transparent !important; }
            `}</style>
        </>
    );
};

const styles = {
    hidden: { position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', top: '-9999px', left: '-9999px' },
};

export default GoogleTranslateWidget;
